var _path, _path2, _path3, _g, _path4, _g2, _g3, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 94,
    viewBox: "0 0 84 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9053_58829",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 94
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "url(#paint0_linear_9053_58829)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9053_58829)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "url(#paint1_linear_9053_58829)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "#F2AA50"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 36.4219,
    x2: 61.4557,
    y2: 36.4219,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 45.5776,
    x2: 61.4557,
    y2: 45.5776,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 54.7332,
    x2: 61.4557,
    y2: 54.7332,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 63.8896,
    x2: 61.4557,
    y2: 63.8896,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 73.0453,
    x2: 61.4557,
    y2: 73.0453,
    stroke: "white",
    strokeWidth: 12
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9053_58829",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 94
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "url(#paint2_linear_9053_58829)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9053_58829)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: -8.49258,
    cy: -1.9842,
    rx: 69.0221,
    ry: 65.4643,
    fill: "url(#paint3_linear_9053_58829)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: -8.49213,
    cy: -1.98353,
    rx: 43.3897,
    ry: 41.0487,
    fill: "url(#paint4_linear_9053_58829)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9053_58829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 31.1299H74.5C62.3497 31.1299 52.5 21.2801 52.5 9.12988V0L84 31.1299Z",
    fill: "#CC9249"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 60.26C6.09533 60.26 6.35967 60.26 6.793 60.26C7.235 60.26 7.75067 60.26 8.34 60.26C8.938 60.26 9.53167 60.2643 10.121 60.273C10.719 60.273 11.2173 60.2773 11.616 60.286C13.8953 60.338 15.75 60.7453 17.18 61.508C18.6187 62.2707 19.676 63.3367 20.352 64.706C21.028 66.0753 21.366 67.696 21.366 69.568C21.366 71.518 21.0107 73.2037 20.3 74.625C19.5893 76.0377 18.5017 77.1297 17.037 77.901C15.581 78.6723 13.7307 79.058 11.486 79.058H6V60.26ZM9.822 63.328V75.99H11.564C12.6387 75.99 13.6137 75.782 14.489 75.366C15.373 74.95 16.0793 74.2697 16.608 73.325C17.1367 72.3803 17.401 71.1193 17.401 69.542C17.401 67.3493 16.881 65.7677 15.841 64.797C14.8097 63.8177 13.4013 63.328 11.616 63.328H9.822Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9259 79.318C31.1492 79.318 29.6109 78.9323 28.3109 78.161C27.0196 77.3897 26.0186 76.2847 25.3079 74.846C24.6059 73.4073 24.2549 71.6913 24.2549 69.698C24.2549 67.696 24.6102 65.9713 25.3209 64.524C26.0402 63.068 27.0499 61.95 28.3499 61.17C29.6499 60.39 31.1752 60 32.9259 60C34.6679 60 36.1846 60.39 37.4759 61.17C38.7672 61.95 39.7639 63.068 40.4659 64.524C41.1766 65.9713 41.5319 67.696 41.5319 69.698C41.5319 71.6827 41.1809 73.3943 40.4789 74.833C39.7856 76.2717 38.7932 77.381 37.5019 78.161C36.2106 78.9323 34.6852 79.318 32.9259 79.318ZM32.9259 76.198C34.2952 76.198 35.3829 75.6997 36.1889 74.703C37.0036 73.6977 37.4109 72.0467 37.4109 69.75C37.4109 67.4013 37.0036 65.7113 36.1889 64.68C35.3742 63.64 34.2866 63.12 32.9259 63.12C31.5566 63.12 30.4602 63.64 29.6369 64.68C28.8222 65.72 28.4149 67.41 28.4149 69.75C28.4149 72.0467 28.8222 73.6977 29.6369 74.703C30.4602 75.6997 31.5566 76.198 32.9259 76.198Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7715 60C54.1841 60 55.4408 60.286 56.5415 60.858C57.6508 61.4213 58.5434 62.1927 59.2195 63.172C59.9041 64.1513 60.3071 65.2563 60.4285 66.487H56.4505C56.2685 65.5077 55.8611 64.7017 55.2285 64.069C54.5958 63.4363 53.7378 63.12 52.6545 63.12C51.3371 63.12 50.3015 63.614 49.5475 64.602C48.8021 65.5813 48.4295 67.2323 48.4295 69.555C48.4295 71.895 48.8021 73.5893 49.5475 74.638C50.3015 75.678 51.3371 76.198 52.6545 76.198C53.7378 76.198 54.5958 75.8383 55.2285 75.119C55.8611 74.391 56.2685 73.5373 56.4505 72.558H60.4285C60.3158 73.4507 60.0991 74.3043 59.7785 75.119C59.4578 75.9337 59.0028 76.6573 58.4135 77.29C57.8241 77.914 57.0658 78.408 56.1385 78.772C55.2198 79.136 54.0975 79.318 52.7715 79.318C51.0208 79.318 49.5085 78.9107 48.2345 78.096C46.9605 77.2813 45.9768 76.1373 45.2835 74.664C44.5988 73.1907 44.2565 71.4703 44.2565 69.503C44.2565 67.527 44.5988 65.8327 45.2835 64.42C45.9681 62.9987 46.9431 61.9067 48.2085 61.144C49.4825 60.3813 51.0035 60 52.7715 60Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1597 79.058H74.4277L70.1897 72.272L66.0297 79.058H61.9477L68.2007 69.516L62.1427 60.26H66.8357L70.5927 66.344L74.3107 60.26H78.3407L72.5427 69.022L79.1597 79.058Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9053_58829",
    x: 29.5,
    y: -24,
    width: 81.5,
    height: 81.1299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9053_58829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9053_58829",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9053_58829",
    x1: 42,
    y1: 0,
    x2: 42,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9053_58829",
    x1: 0,
    y1: 0,
    x2: 96.4083,
    y2: 78.8235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A0A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85C894"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9053_58829",
    x1: 42,
    y1: 0,
    x2: 42,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85567"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9053_58829",
    x1: -3.48108,
    y1: 0.265432,
    x2: 17.0213,
    y2: 55.3258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9053_58829",
    x1: -5.34172,
    y1: -0.57292,
    x2: 7.48934,
    y2: 33.9735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.a5da6d5817b66ff5f0324406b7752ada.svg";
export { ForwardRef as ReactComponent };